import { css } from 'linaria';

export const tintPriceSkeleton = css`
  width: 98px;
  height: var(--space-200);
  border-radius: var(--rounding-m);
`;
